import Freeze from './assets/Poke_Freeze.png';
import Locked from './assets/Poke_Locked.png';
import Mud from './assets/Poke_Mud.png';
import Shield from './assets/Poke_Shield.png';

export const POKE_BADGES = [
  {
    badgeName: 'Poke Shield',
    image: Shield
  },
  {
    badgeName: 'Poke Freeze',
    image: Freeze
  },
  {
    badgeName: 'Poke Mud',
    image: Mud
  }
];

export const POKE_TYPE = {
  //BATTLE: "battle",
  FREEZE: 'freeze',
  SHIELD: 'shield',
  MUD: 'mud',
  LOCKED: 'locked',
  UNLOCKED: 'unlock'
};

export function iconLookupByType(type) {
  switch (type) {
    case 'Freeze Power Up':
      return Freeze;
    case 'Shield Power Up':
      return Shield;
    case 'Mud Power Up':
      return Mud;
    default:
      return null;
  }
}

export function getPokeIcons(unlockPokeSlots) {
  const count = unlockPokeSlots - 3;
  let pokeSlot1, pokeSlot2, pokeSlot3;
  if (count >= 3) {
    pokeSlot1 = { badgeName: 'Open Slot', image: Freeze };
    pokeSlot2 = { badgeName: 'Open Slot', image: Freeze };
    pokeSlot3 = { badgeName: 'Open Slot', image: Freeze };
  } else if (count === 2) {
    pokeSlot1 = { badgeName: 'Open Slot', image: Freeze };
    pokeSlot2 = { badgeName: 'Open Slot', image: Freeze };
    pokeSlot3 = { badgeName: 'Locked Slot', image: Locked };
  } else if (count === 1) {
    pokeSlot1 = { badgeName: 'Open Slot', image: Freeze };
    pokeSlot2 = { badgeName: 'Locked Slot', image: Locked };
    pokeSlot3 = { badgeName: 'Locked Slot', image: Locked };
  } else if (count === 0) {
    pokeSlot1 = { badgeName: 'Locked Slot', image: Locked };
    pokeSlot2 = { badgeName: 'Locked Slot', image: Locked };
    pokeSlot3 = { badgeName: 'Locked Slot', image: Locked };
  } else {
    pokeSlot1 = { badgeName: 'Open Slot', image: Freeze };
    pokeSlot2 = { badgeName: 'Open Slot', image: Freeze };
    pokeSlot3 = { badgeName: 'Open Slot', image: Freeze };
  }
  const pokesToAdd = [pokeSlot1, pokeSlot2, pokeSlot3];
  const pokesToReturn = POKE_BADGES.concat(pokesToAdd);
  return pokesToReturn;
}

export function lookupBattleInventoryByType(dictonary, type) {
  let toReturn;
  if (type && dictonary) {
    toReturn = dictonary.find(record => matchInventory(record, type));
  }

  if (!toReturn) {
    toReturn = { subCategory: '', count: undefined };
  }
  toReturn.type = type;
  return toReturn;
}

export function matchInventory(record, type) {
  let matchFound = false;

  if (record.subCategory) {
    matchFound = record.subCategory.toLowerCase().includes(type);
  }
  return matchFound;
}
